export default {
  name: 'marking--docLoadCustom',
  apiService: 'shoes',
  apiPath: '/admin/doc/func/loader',
  urlParamName: 'marking--docLoadCustom',
};